export default {
	REGEX_PATTERN: /^[A-Z]{2}-?\w{3}-?\d{2}-?\d{5}$/g,
};
